import { socialBrands } from "../../../shared/lib/constants"
import * as Yup from "yup"

export const brandSelectValues = socialBrands.map(brand => ({ value: brand, label: brand }))

export const validationSchema = Yup.object().shape({
  name: Yup.string().required("Имя обязательно"),
  position: Yup.string().required("Должность обязательна"),
  published: Yup.boolean().required(),
  avatar: Yup.string().required(),
  socials: Yup.array(
    Yup.object()
      .shape({
        brand: Yup.string()
          .oneOf([ "vk", "instagram", "telegram" ])
          .required("Укажите социальную сеть"),
        url: Yup.string()
          .url("Неверный формат ссылки")
          .required("Укажите ссылку на социальную сеть"),
      })
      .optional(),
  ),
})
